// Las noticias antiguas (del sistema PHP) guardaban "Titulo##Cuerpo" en un solo
// campo "contenido". Las nuevas ya traen "titulo" y "contenido" separados.
export const splitTituloContenido = (n) => {
  if (n?.titulo) {
    return { titulo: n.titulo, cuerpo: n.contenido || "" };
  }
  const raw = n?.contenido || "";
  const idx = raw.indexOf("##");
  if (idx === -1) return { titulo: "", cuerpo: raw };
  return { titulo: raw.slice(0, idx).trim(), cuerpo: raw.slice(idx + 2).trim() };
};

// Adjuntos de noticia que se reproducen en la página en vez de descargarse.
export const VIDEO_EXT_NOTICIA = [".mp4", ".webm", ".mov"];
export const esVideoNoticia = (url) => {
  const limpio = String(url || "").split("?")[0].toLowerCase();
  return VIDEO_EXT_NOTICIA.some((ext) => limpio.endsWith(ext));
};

// Adjuntos de imagen: se muestran como portada de la noticia.
export const esImagenNoticia = (url) => /\.(jpe?g|png|webp|gif)$/i.test(String(url || "").split("?")[0]);

// Id del primer video de YouTube enlazado en el texto de una noticia (watch?v=, youtu.be/, shorts/, embed/, live/), o null.
const YOUTUBE_RE =
  /(?:youtube\.com\/(?:watch\?(?:[^\s#]*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i;
export const extraerYoutubeId = (texto) => String(texto || "").match(YOUTUBE_RE)?.[1] || null;

// Texto de la noticia para mostrar, sin el enlace ni el código <iframe> de YouTube (el video ya se ve aparte).
// Lo guardado no cambia: al editar la noticia el enlace sigue ahí.
export const quitarYoutubeDelTexto = (texto) =>
  String(texto || "")
    .replace(/<iframe\b[^>]*youtu[^>]*>[\s\S]*?(<\/iframe>|$)/gi, "")
    .replace(/https?:\/\/(?:www\.|m\.)?(?:youtube(?:-nocookie)?\.com|youtu\.be)\/\S+/gi, "")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

// Enlace de una app de Google Play en el texto (play.google.com/store/apps/details?id=...): se muestra como
// tarjeta de descarga con QR. Devuelve { url, paquete } o null.
const PLAY_STORE_RE = /https?:\/\/play\.google\.com\/store\/apps\/details\?[^\s<>"']*?\bid=([A-Za-z0-9._]+)[^\s<>"']*/i;
export const extraerPlayStore = (texto) => {
  const m = String(texto || "").match(PLAY_STORE_RE);
  return m ? { url: m[0], paquete: m[1] } : null;
};

// Texto de la noticia para mostrar: sin los enlaces que ya se ven aparte (video de YouTube, tarjeta de Google Play).
export const textoParaMostrar = (texto) =>
  quitarYoutubeDelTexto(String(texto || "").replace(new RegExp(PLAY_STORE_RE.source, "gi"), ""))
    .replace(/[ \t]{2,}/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

export const SUCURSALES_NOTICIA = [
  "Nacional",
  "La Paz",
  "La Paz(El Alto)",
  "Santa Cruz",
  "Cochabamba",
  "Beni",
  "Pando",
  "Chuquisaca",
  "Potosi",
  "Tarija",
  "Oruro",
];
